var map = {
	"./CLOTHE1.svg": 42328,
	"./CLOTHE10.svg": 97114,
	"./CLOTHE11.svg": 57329,
	"./CLOTHE12.svg": 27121,
	"./CLOTHE2.svg": 54838,
	"./CLOTHE3.svg": 80841,
	"./CLOTHE4.svg": 95274,
	"./CLOTHE5.svg": 76063,
	"./CLOTHE6.svg": 54910,
	"./CLOTHE7.svg": 48908,
	"./CLOTHE8.svg": 44813,
	"./CLOTHE9.svg": 88864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64019;